import { render, staticRenderFns } from "./regist-group.vue?vue&type=template&id=01da9fb0&scoped=true&"
import script from "./regist-group.vue?vue&type=script&lang=js&"
export * from "./regist-group.vue?vue&type=script&lang=js&"
import style0 from "./regist-group.vue?vue&type=style&index=0&id=01da9fb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da9fb0",
  null
  
)

export default component.exports